import { useEffect } from 'react'
import { Box } from '~/design_system'
import { useMsg } from '~/common/localizationUtils'

export function JqueryMessageShim() {
  const msg = useMsg()
  useEffect(() => {
    // @ts-ignore
    window.msg = msg
  }, [msg])
  return <Box />
}
